import React, { useState, useMemo, useCallback } from 'react';

import './ArrowDown.scss';

function ArrowDown() {
  const [opacity, setopacity] = useState(1);

  const handleNavigation = useCallback((e) => {
    const _window = e.currentTarget;
    const _opacity = 1 - _window.pageYOffset / 100;
    setopacity(_opacity > 0 ? _opacity : 0);
  }, []);

  useMemo(() => {
    window.addEventListener('scroll', handleNavigation);

    return () => {
      // return a cleanup function to unregister our function since its gonna run multiple times
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  return (
    <div
      className="arrow"
      style={{ opacity, display: !!opacity ? 'block' : 'none' }}
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default React.memo(ArrowDown);
